import { DrugTypeEnum, Product, DosageTypeEnum } from "../../../typings/types"
import { Product as ProductType } from "../../../typings/products"

/**
 * we use various product properties to determine whether or not we generate or link to a product page
 *
 * due to legal complications, we are currently filtering out the cambia PDP
 * https://github.com/ThirtyMadison/cove/issues/2028
 *
 * the ODT pdps do not resolve to anything right now, removing links to ODT pdps besides nurtec
 * https://github.com/ThirtyMadison/cove/issues/2293
 *
 * @param p - the product
 */
export const showPDP = (p: Product | ProductType) => {
  if (p.drugType === DrugTypeEnum.Rimegepant) {
    return true
  } else if (!p.userSelectable || p.drugType === DrugTypeEnum.Diclofenac || p.dosageType === DosageTypeEnum.OdtMg) {
    return false
  }
  return true
}
